import { ROUTES } from "base/routes/routes";
import dayjs from "dayjs";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { ExclamationCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { FaRecycle, FaBox } from "react-icons/fa";

import warning from 'assets/images/warning.png'
import packageBox from 'assets/images/image96.png'


type CardItemProps = {
  data: {
    id: string;
    title: string;
    isCreateBySystem: boolean | null;
    expectedDate: string;
    vendor: string;
    //   Số xe
    licensePlate: string;
    //   Tài xế
    driverName: string;
    checkIn?: string;
    checkOut?: string;
    reason?: string;
    workflowCode?: string;
    productCode?: string;
    productName?: string;
    kanbanIcon?: string;
  };
  icon?: ReactNode;
  color?: string;
  hidenCheckInOut?: boolean;
  hidenReason?: boolean;
}
export const CardItem = (props: CardItemProps) => {
  const { data, color, hidenCheckInOut, hidenReason = true, icon } = props
  const {
    driverName,
    expectedDate,
    licensePlate,
    title,
    vendor,
    checkIn,
    checkOut,
    reason,
    isCreateBySystem,
    workflowCode,
    productCode,
    productName,
    kanbanIcon,
  } = data
  const isWasteMaterial = workflowCode === 'WasteMaterial';
  const isMaterial = workflowCode === 'AVN_WF';

  // Xác định icon và tooltip dựa trên workflowCode và kanbanIcon
  const getKanbanIcon = () => {
    if (isWasteMaterial) {
      // Chất thải: dùng kanbanIcon để phân biệt nguy hại (WARNING) và thông thường (RECYCLE)
      if (kanbanIcon === 'WARNING') {
        return (
          <Tooltip title="Chất thải nguy hại">
            <img src={warning} className='w-5' />
          </Tooltip>
        );
      } else if (kanbanIcon === 'RECYCLE') {
        return (
          <Tooltip title="Chất thải thông thường & rác sinh hoạt">
            <FaRecycle className="text-green-500" style={{ fontSize: '16px' }} />
          </Tooltip>
        );
      } else if (kanbanIcon === 'BOX') {
        // Nguyên vật liệu: dùng icon box màu cam
        return (
          <Tooltip title="Nguyên vật liệu">
            {/* <FaBox className="text-orange-500" style={{ fontSize: '16px' }} /> */}
            <img src={packageBox} className='w-5' />
          </Tooltip>
        );
      }
      else {
        // Mặc định cho chất thải
        return (
          <Tooltip title="Chất thải">
            <WarningOutlined className="text-yellow-500" style={{ fontSize: '16px' }} />
          </Tooltip>
        );
      }
    } else if (isMaterial) {
      // Nguyên vật liệu: dùng icon box màu cam
      return (
        <Tooltip title="Nguyên vật liệu">
          {/* <FaBox className="text-orange-500" style={{ fontSize: '16px' }} /> */}
          <img src={packageBox} className='w-5' />

        </Tooltip>
      );
    }
    return icon;
  };

  // Xác định label thời gian dựa trên workflowCode
  const getTimeLabel = () => {
    if (isWasteMaterial) {
      return 'TG bàn giao dự kiến';
    } else if (isMaterial) {
      return 'TG nhận hàng dự kiến';
    }
    return 'TG nhận hàng dự kiến';
  };

  // Xác định route dựa trên workflowCode
  const getRoute = () => {
    if (workflowCode === 'WasteMaterial') {
      return ROUTES.WASTE_HANDOVER_REGISTRATION.EDIT_REGISTRATION.LINK + '/' + data.id;
    } else {
      return ROUTES.PURCHASE_ORDER.LIST_PO.EDIT_VOTE.LINK + '/' + data.id;
    }
  };

  return (
    <Link to={getRoute()} className='!text-black'>
      <div className="w-full p-1 px-2.5 shadow-box hover:shadow-md hover:opacity-85 duration-150 rounded text-xs" style={{ background: color }}>
        <div className='flex items-center'>
          <div className='my-1 flex items-center gap-2 flex-1 min-w-0'>
            {getKanbanIcon()}
            <h3 className={`uppercase font-semibold flex-1 break-words ${isCreateBySystem ? "text-[#dc2626]" : ""}`}
              style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>{title}</h3>
          </div>
          <div className='flex-shrink-0 flex items-center justify-center text-[10px] h-[20px] rounded-lg'
            style={{ backgroundColor: isWasteMaterial ? '#dc2626' : '#069e15', color: '#fff', minWidth: '60px', textAlign: 'center' }}>
            {isWasteMaterial ? 'Chất thải' : 'NVL'}
          </div>
        </div>

        <div className='w-full text-default'>
          <span className='col-span-2'>Công ty: <strong className='font-medium'>{vendor}</strong></span>
        </div>
        <span >Số xe: <strong className='font-medium'>{licensePlate}</strong></span>
        <span className='block'>{getTimeLabel()}: <strong className='font-medium'>{expectedDate && dayjs(expectedDate).format("HH:mm DD/MM/YYYY")}</strong></span>
        <span className='block'>Tài xế: <strong className='font-medium'>{driverName}</strong></span>
        {/* Hiển thị thông tin hàng hóa cho chất thải/phế liệu */}
        {isWasteMaterial && productCode && productName && (
          <span className='block'>CT/PL: <strong className='font-medium'>{productCode} | {productName}</strong></span>
        )}
        {!hidenCheckInOut && (<>
          <span className='block'>Vào cổng: <strong className='font-medium'>{checkIn && dayjs(checkIn).format("HH:mm DD/MM/YYYY")}</strong></span>
          <span className='block'>Ra cổng: <strong className='font-medium'>{checkOut && dayjs(checkOut).format("HH:mm DD/MM/YYYY")}</strong></span>
        </>)}
        {!hidenReason && (
          <span className='block'>Lý do từ chối: {reason}</span>
        )}
      </div>
    </Link>
  )
}
